import { Component, AfterViewInit, Inject, HostListener, NgZone, ElementRef, DOCUMENT, HostBinding } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  Router, NavigationStart, NavigationEnd,
  NavigationCancel, NavigationError, ActivatedRouteSnapshot,
  RouterOutlet
} from '@angular/router';
import { HttpBackend, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ToasterService } from './services/toaster.service';
import { environment } from '../environments/environment';
import { IpcUtilService } from '@otas/utils/directives/helper/ipc-util.service';
import { TranslateService } from '../translate/translate.service';
import { LoginStodaService } from './login-stoda/login-stoda.service';
import { interval } from 'rxjs';
import { ProgressBarService } from './shared/progress-bar/progress-bar.service';
import { debounceTime, finalize } from 'rxjs/operators';
import { PanchangService } from '@otas/utils/custom-components/panchang-calendar/panchang.service';
import { jsPDF } from 'jspdf';
import { addFile } from './model/abc-helper/jspdf';
import { GlobalUtilService } from '@otas/core/services/global-util.service';
import { Event as RouterEvent } from '@angular/router';
import { AppConstants } from './app.constants';
import { FlexModule } from '@ngbracket/ngx-layout';
import { LoaderSpinnerComponent } from '@shivam/loader-spinner/loader-spinner.component';
import { LoaderService } from '@otas/core/services/loader.service';
import { PaymentService } from '@shivam/services/payment.service';
import { AuthenticationService } from '@shivam/shared/auth/authentication.service';
import { WINDOW } from './services/window.provider';
import { CurrentUser } from './model/current-user';
import { AFTER_LOGIN_ACTION } from '@shivam/model/login-enum';
import moment from 'moment';
import { ModuleVersionService } from './services/module-version.service';
import { classicRouteForUrl } from './services/module-version-menu';
import { getCurrentWindow } from '@tauri-apps/api/window';
import { PrintFailureMonitorService } from './shared/ui/print-monitor/print-failure-monitor.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [LoginStodaService, LoaderSpinnerComponent, FlexModule, RouterOutlet],
  standalone: false
})
export class AppComponent implements AfterViewInit {
  loading = false;
  title = 'app';
  progress = 0;
  intervalSubscription;
  clockTick;
  progressBarLoading: boolean;
  bgColor;
  bgColorCode = AppConstants.bgColor;
  http: HttpClient;
  // title = 'shivam-frontend';
  preloader = true;
  countryCode: any;
  host: string;
  templeName: string;
  constructor(private readonly el: ElementRef, private titleService: Title,
    private loginService: LoginStodaService, private progressBarSevice: ProgressBarService,
    private ngZone: NgZone,
    @Inject(DOCUMENT) private document: any, private _translate: TranslateService, private panchangService: PanchangService,
    private toastr: ToasterService, private globalUtilService: GlobalUtilService,
    private router: Router, ipcutil: IpcUtilService, private elementRef: ElementRef,
    //shivam
    private loaderService: LoaderService,
    httpBackend: HttpBackend,
    private paymentService: PaymentService,
    private authenticationService: AuthenticationService,
    @Inject(WINDOW) private window: Window,
    private moduleVersionService: ModuleVersionService,
    printFailureMonitor: PrintFailureMonitorService
  ) {
    // R45: global print-chain-failed listener — an exhausted print-method
    // chain now toasts on EVERY screen (self no-ops outside the desktop app).
    printFailureMonitor.init();
    if (this.globalUtilService.isTauriApp) {
      const api = this.globalUtilService.API;
      const port = this.globalUtilService.PORT;
      this.bgColorCode = this.globalUtilService.bgColor;
      if (!!api) {
        const serverUrl = 'http://' + api + ':' + (!!port ? port : '8383') + '/';
        environment.apiUrl = serverUrl;
      }
    } else {
      this.bgColorCode = '#5dbcd2';
    }
    this.getBgColor();
    this.loaderService.secondaryLoader.next(true);
    router.events.subscribe((event: RouterEvent) => {

      this.navigationInterceptor(event);
      this.loaderInterceptor(event);
    });
    if (this.globalUtilService.isTauriApp)
      ipcutil.keyboardType = ipcutil.getKeyBoardType();

    this.http = new HttpClient(httpBackend);
    this.host = this.domain_from_url(this.getHostname());
    // console.log('inside app component');
    // this.getVersionCheck(); // Not checking version in online due to elamkulam rate change bug
    this.templeName = JSON.parse(localStorage.getItem('temple') || '[]')[0]?.name; // 2023
    this.getCurrentCountryCode();
    this.getCurrentTime();
    // NOTE: the old startup `startPrintService()` call is deliberately GONE.
    // cloud-printing.jar is one-shot, not a daemon: launched with no -D args it
    // re-renders the LAST printing.properties and prints it — so every app
    // start replayed the previous receipt (the "Save Print Output As" dialog
    // when the effective printer is Microsoft Print to PDF, a silent duplicate
    // on a real printer). Real prints spawn their own jar run per request
    // (Rust `handlePrintRequest`), so nothing needs "starting" at boot.
  }

  // @HostListener('window:keyup', ['$event'])
  // onKeyUp(event: KeyboardEvent) {
  //   if (this.globalUtilService.isTauriApp && event.altKey && event.key === 'F11') {
  //     this.globalUtilService.IPCRendererSend('toggleDevtools');
  //   }
  // }

  @HostListener('window:keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (this.globalUtilService.isTauriApp && event.altKey && event.key === 'F11') {
      this.globalUtilService.IPCRendererSend('toggleDevtools');
    }
    if (event.key === 'Home') {
      // Follows the per-temple VAZHIPADU module version (V2 default).
      this.router.navigate([this.moduleVersionService.bookingRoute()]);
    }
    // Alt+O: from any V2 Transaction screen, open its classic (V1) sibling.
    // No-op on pages without a classic sibling (classicRouteForUrl → null).
    if (event.altKey && !event.ctrlKey && !event.shiftKey && (event.key === 'o' || event.key === 'O')) {
      const classicRoute = classicRouteForUrl(this.router.url);
      if (classicRoute) {
        event.preventDefault();
        this.router.navigate([classicRoute]);
      }
    }
    if (this.el.nativeElement.ownerDocument.activeElement === this.document.body) {
      event.preventDefault();
      this.focusFirstElement(100);
    }
  }

  @HostListener('window:blur', ['$event']) onBlur(event: KeyboardEvent) {
    if (this.el.nativeElement.ownerDocument.activeElement === this.document.body) {
      event.preventDefault();
      this.focusFirstElement(100);
    }
  }

  @HostListener('window:focus', ['$event']) onFocus(event: KeyboardEvent) {
    if (this.el.nativeElement.ownerDocument.activeElement === this.document.body) {
      event.preventDefault();
      this.focusFirstElement(100);
    }
  }

  @HostBinding('class.main-layout') isMainLayout = true;

  private focusFirstElement(timeout = 100) {
    setTimeout(() => {
      const fields = this.getFormFields();
      if (fields.length > 0) {
        fields[0].focus();
      }
    }, timeout);
  }
  private getFormFields(): HTMLElement[] {
    // Use querySelector to find the elements instead of jQuery
    return Array.from(this.el.nativeElement.querySelectorAll(AppConstants.toSearch));
  }

  ipcRendrerCloseEvent(event) {
    sessionStorage.removeItem('CURRENT_USER');
    this.ngZone.run(() => {
      this.router.navigate(['/login-stoda']).then((d) => {
        event.sender.send('logout')
      });
    });
  }
  progressBarStatusListener() {
    this.progressBarSevice.status.pipe(debounceTime(200)).subscribe((value: boolean) => {
      if (value === true) {
        (document.activeElement as any).blur();
        this.intervalSubscription = interval(2400).subscribe((data) => {
          this.progress++;
          if (this.progress === 100) {
            this.progress = this.progress - data;
            if (this.progress < 0) {
              this.progress = data - this.progress;
            }
            this.intervalSubscription.unsubscribe();
          }
        });
      } else if (value === false && this.intervalSubscription) {
        this.progress = 0;
        this.intervalSubscription.unsubscribe();
      }
      this.progressBarLoading = value;
    })
  }
  getBgColor() {
    if (this.globalUtilService.isTauriApp) {
      // In Tauri, we don't directly read from fs like this anymore, 
      // but we keep the logic structure if we implement a Tauri-based fetch later.
      this.bgColor = '#5dbcd2';
    } else {
      this.bgColor = '#5dbcd2';
    }
  }
  autoLogin() {
    const request = { "userName": "test", "password": "123", "counter": null, "ip": "bb792de0649b4bf897115000bfbf099d", "language": "ml" }
    if (environment.apiUrl.includes('http://sms.clouddimension.in:8080/')) {
      this.loginService.login(request).pipe(finalize(() => { this.loading = false; })).subscribe((res) => {
        if (res.status === 'SUCCESS') {
          const currentUser = res.result;
          sessionStorage.setItem('CURRENT_USER', JSON.stringify(currentUser));
          // this.router.navigate(['app/settings/stoda-settings']);
          // this.router.navigate(['app/reports/pooja/collection']);
          // this.router.navigate(['app/reports/pooja-collection-report-revised']);
          // this.router.navigate(['app/stoda/expense-billing-stoda']);
          this.router.navigate([this.moduleVersionService.bookingRoute()]);

        }
      });
    }
  }
  ngAfterViewInit() {
    document.body.style.backgroundColor = (!!this.bgColorCode) ? this.bgColorCode : AppConstants.bgColor;

    const pdf = new jsPDF();
    addFile(pdf);
    if (this.globalUtilService.isTauriApp)
      this.globalUtilService.IPCRendererOn('close', this.ipcRendrerCloseEvent.bind(this));
    this.progressBarStatusListener();
    if (this.hasScrollbar()) {
      document.body.classList.add('hasScrollbar');
    }
    // !environment.production&&this.autoLogin();

    this.panchangService.todayPanchangObs.subscribe((e) => {
      if (e) {
        this.updateWindowTitle();
      }
    });
    this.afterSocioLoginListener();
  }
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
      this.checkMainLayout(event);
    }
    if (event instanceof NavigationEnd) {
      this.loading = false;
      this.updateWindowTitle();
      // If url contains '/shivam', disable the main layout class
      this.checkMainLayout(event);
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loading = false;
    }
    if (event instanceof NavigationError) {
      if (event.error instanceof HttpErrorResponse && event.error.message === 'Http failure response for (unknown url): 0 Unknown Error') {
        if (event.error.status === 0) {
          this.router.navigate(['/error']);

        } else {
          this.toastr.error('Please Login ', 'INVALID_TOKEN !!');
          this.router.navigate(['/login-stoda']);
        }
      }
      this.loading = false;
    }
  }
  hasScrollbar() {
    // The Modern solution
    if (typeof window.innerWidth === 'number') {
      return window.innerWidth > document.documentElement.clientWidth;
    }

    // rootElem for quirksmode
    const rootElem = document.documentElement || this.document.body;

    // Check overflow style property on body for fauxscrollbars
    let overflowStyle;

    if (typeof rootElem.currentStyle !== 'undefined') {
      overflowStyle = rootElem.currentStyle.overflow;
    }

    overflowStyle = overflowStyle || window.getComputedStyle(rootElem, '').overflow;

    // Also need to check the Y axis overflow
    let overflowYStyle;

    if (typeof rootElem.currentStyle !== 'undefined') {
      overflowYStyle = rootElem.currentStyle.overflowY;
    }

    overflowYStyle = overflowYStyle || window.getComputedStyle(rootElem, '').overflowY;

    const contentOverflows = rootElem.scrollHeight > rootElem.clientHeight;
    const overflowShown = /^(visible|auto)$/.test(overflowStyle) || /^(visible|auto)$/.test(overflowYStyle);
    const alwaysShowScroll = overflowStyle === 'scroll' || overflowYStyle === 'scroll';

    return (contentOverflows && overflowShown) || (alwaysShowScroll);
  }
  /**
   * "SHIVAM <route> - <page title>[ - <panchang>]" on document.title AND the
   * native Tauri title bar (which does NOT follow document.title, so the
   * route was previously invisible on the desktop window).
   */
  private updateWindowTitle(): void {
    const route = this.router.url.split('?')[0].split('#')[0];
    let title = 'SHIVAM ' + route + ' - ' + this.getPageTitle(this.router.routerState.snapshot.root);
    if (this.panchangService.todayPanchangObs.value) {
      const panchang = this.panchangService.todayPanchang[0];
      const isMalayalam = sessionStorage.getItem('language') === 'malayalam';
      const year = isMalayalam ? panchang.year : panchang.enYear;
      const star = isMalayalam ? panchang.nakshathra : panchang.enNakshathra;
      const thithi = isMalayalam ? panchang.thithi : panchang.enThithi;
      title += ' - ' + year + ' ' + star + ' ' + thithi;
    }
    this.titleService.setTitle(title);
    if (this.globalUtilService.isTauriApp) {
      getCurrentWindow().setTitle(title).catch(() => { /* capability missing — document.title still set */ });
    }
  }

  private getPageTitle(routeSnapshot: ActivatedRouteSnapshot) {
    let title: string = (routeSnapshot.data && routeSnapshot.data['pageTitle']) ? routeSnapshot.data['pageTitle'] : 'STODA';
    if (routeSnapshot.firstChild) {
      title = this.getPageTitle(routeSnapshot.firstChild) || title;


    }
    return this._translate.instant(title);
  }

  private checkMainLayout(event: NavigationStart | NavigationEnd): void {
    const url = (event instanceof NavigationEnd) ? event.urlAfterRedirects : event.url;
    this.isMainLayout = !AppConstants.isShivamRoute(url);
    if (!this.isMainLayout) {
      document.body.style.backgroundColor = AppConstants.shivamBgColor;
    } else {
      document.body.style.backgroundColor = (!!this.bgColorCode) ? this.bgColorCode : AppConstants.bgColor;
      // document.body.style.color = AppConstants.textColor;
    }
  }

  loaderInterceptor(event: Event | RouterEvent) {
    if (event instanceof NavigationStart) {
      this.loaderService.show();
    }
    if (event instanceof NavigationEnd) {
      this.loaderService.hide();
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loaderService.hide();
    }

    if (event instanceof NavigationError) {
      // R43 fix: this called show() — inverted against its own comment above —
      // so ANY failed navigation left the global 3-dot preloader animating
      // forever over the still-rendered page (every HTTP-driven show() self-
      // hides at the Sent event; this was the one un-paired show()).
      this.loaderService.hide();
    }
  }

  getVersionCheck() { // Ajesh commented for temporary fixing elamkulam rate change bug
    const _temple: any[] | null | undefined = JSON.parse(localStorage.getItem('temple'));
    const version: string | null | undefined = (!!_temple && !!_temple[0]?.dataVersion) ? _temple[0]?.dataVersion : null;
    // this.http.get<{ temple: any[], pooja: any[], deity: any[] }>(`${environment.apiUrl}version/check/${version}/${this.host}/null`)
    this.http.get<{ temple: any[], pooja: any[], deity: any[] }>(`${environment.apiUrl}all/${this.host}/null`)
      .subscribe((response) => {
        if (!!response) {
          const templeArray: any[] = response.temple;
          const poojaList = response.pooja;
          const deityList = response.deity;
          localStorage.setItem('tuid', templeArray[0].tuid);
          localStorage.setItem('templeHome', templeArray[0].homeUrl);
          localStorage.setItem('temple', JSON.stringify(templeArray));
          localStorage.setItem('pooja', JSON.stringify(poojaList));
          localStorage.setItem('deity', JSON.stringify(deityList));
        }
      });
  }

  getCurrentCountryCode() {
    this.http.get('https://get.geojs.io/v1/ip/country.json').subscribe((resp: any) => {
      this.countryCode = (resp?.country || '').toLowerCase();
      (window as any).intlTelInputGlobals.initialCountry = this.countryCode;
      localStorage.setItem('countryCode', this.countryCode)
    }, error => {
      (window as any).intlTelInputGlobals.initialCountry = 'in'
      localStorage.setItem('countryCode', this.countryCode = 'in')
    })
  }

  getCurrentTime() {
    // Server-synchronised clock: one timezone fetch fixes a server-vs-local
    // offset and window.currentdate becomes a getter computed on every read —
    // no drift (unlike the old +1s-per-tick mutation), and reads before the
    // response arrives fall back to the local clock (offset 0).
    let serverOffsetMs = 0;
    Object.defineProperty(window, 'currentdate', {
      configurable: true,
      get: () => new Date(Date.now() + serverOffsetMs)
    });
    this.http.get<any>(`${environment.apiUrl}api/timezone/Asia/Kolkata`)
      .subscribe({
        next: resp => {
          serverOffsetMs = moment(resp.result).toDate().getTime() - Date.now();
        },
        error: () => {
          serverOffsetMs = 0;
        }
      });

    // App-wide change-detection heartbeat. This legacy app has many screens
    // (e.g. the Pooja Collection report) whose data arrives through manual
    // Subjects / third-party callbacks that don't reliably schedule a change
    // detection pass, so they only repainted because a 1-second interval kept
    // firing a global CD tick. `interval` runs on zone.js-patched setInterval,
    // so each tick re-enters the Angular zone and triggers that tick. Kept as a
    // no-op timer (the clock value itself now comes from the getter above);
    // removing it made those screens render only after the next user click.
    this.ngZone.runOutsideAngular(() => {
      this.clockTick = interval(1000).subscribe(() => this.ngZone.run(() => { }));
    });
  }

  domain_from_url(url) { // new
    let result: string;
    let match = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n\?\=]+)/im);
    if (!!match) {
      result = match[1];
      match = result.match(/^[^\.]+\.(.+\..+)$/);
      if (!!match) {
        result = match[1];
      }
    }
    return result;
  }

  getHostname(): string {// new
    return this.window.location.hostname;
  }

  @HostListener('window:load', ['$event'])
  onWindowLoad(event) {
    this.loaderService.secondaryLoader.next(false);
  }

  afterSocioLoginListener() {
    this.authenticationService.loginCompleted.subscribe((action) => {
      switch (action) {
        case 'SUCCESS':
          const currentUser: CurrentUser = JSON.parse(localStorage.getItem('currentUser'));
          const roles = currentUser?.roles?.map(e => e.name) || [];
          if (this.authenticationService.afterLogin.value === AFTER_LOGIN_ACTION.PAYMENT) {
            this.paymentService.payment();
          }
          break;
      }
    });
  }
}

